//#region IMPORT
import React from 'react';
/** Components Import */
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Stack,
  Avatar,
  ListItemButton,
  Chip,
} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import DeleteIcon from '@mui/icons-material/Delete';
import { IsTraCustom02EduLogAlarmGubun } from '../../Presets/NotiPreset';
/** Icons Import */
//#endregion

function AlarmList(props) {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Chip 필터 영역 - 고정 */}
      <Stack sx={{ p: 2, flexShrink: 0 }} direction="row" gap={1}>
        <Swiper slidesPerView="auto" spaceBetween={6}>
          {props.chipItems.map((item, index) => (
            <SwiperSlide key={index} style={{ width: 'auto' }}>
              <Chip
                key={index}
                sx={{
                  borderRadius: 2.5,
                  backgroundColor: props.chipIndex === index && '#444B53',
                  color: props.chipIndex === index && '#FFF',
                  '&:hover': {
                    backgroundColor: props.chipIndex === index && '#333',
                  },
                }}
                label={item.label}
                onClick={() => props.ChipClick(index)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Stack>

      {/* 알림 리스트 영역 - 스크롤 */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        {props.alarmList.length !== 0 ? (
          <List
            sx={{
              width: '100%',
              p: 0,
            }}
          >
            {props.alarmList.map((item, index) => (
              <React.Fragment key={index}>
                <Box
                  sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    width: '100%',
                    opacity: props.deletingAlarmCd === item.alarmCd ? 0 : 1,
                    transform:
                      props.deletingAlarmCd === item.alarmCd
                        ? 'translateX(-100%)'
                        : 'translateX(0)',
                    transition:
                      props.deletingAlarmCd === item.alarmCd
                        ? 'opacity 0.3s ease, transform 0.3s ease'
                        : 'none',
                  }}
                  onTouchStart={props.SwipeTouchStart}
                  onTouchMove={props.SwipeTouchMove}
                  onTouchEnd={() => props.SwipeTouchEnd(index)}
                >
                  {/* 삭제 버튼 영역 */}
                  <Box
                    sx={{
                      my: 0.5,
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      bottom: 0,
                      width: '90px',
                      backgroundColor: '#FF3B30',
                      borderRadius: '0 16px 16px 0',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 0.5,
                      zIndex: 1,
                      transform:
                        props.swipedIndex === index
                          ? 'translateX(0)'
                          : 'translateX(calc(100% + 8px))',
                      transition:
                        'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      cursor: 'pointer',
                      '&:active': {
                        backgroundColor: '#D32F2F',
                        transform:
                          props.swipedIndex === index
                            ? 'translateX(0) scale(0.98)'
                            : 'translateX(calc(100% + 8px))',
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.HandleDeleteClick(item);
                    }}
                  >
                    <DeleteIcon
                      sx={{
                        color: 'white',
                        fontSize: 20,
                      }}
                    />
                    <Typography
                      sx={{
                        color: 'white',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        letterSpacing: '0.2px',
                      }}
                    >
                      삭제
                    </Typography>
                  </Box>

                  {/* 알림 컨텐츠 영역 */}
                  <ListItem
                    sx={{
                      p: 0,
                      transform:
                        props.swipedIndex === index
                          ? 'translateX(-98px)'
                          : 'translateX(0)',
                      transition:
                        'transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      backgroundColor: 'white',
                      marginRight: props.swipedIndex === index ? '8px' : '0',
                    }}
                  >
                    <ListItemButton
                      sx={{
                        borderRadius:
                          props.swipedIndex === index
                            ? '16px 0 0 16px'
                            : '16px',
                        my: 0.5,
                        display: 'flex',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        backgroundColor:
                          props.swipedIndex === index
                            ? '#F5F5F5'
                            : item.useYn === 'Y'
                              ? '#F3F7F8'
                              : 'white',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                        '&:hover': {
                          backgroundColor:
                            props.swipedIndex === index
                              ? '#F5F5F5'
                              : item.useYn === 'Y'
                                ? '#D1E3E6'
                                : '#F5F5F5',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        },
                        transition:
                          'all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      }}
                      onClick={() => {
                        if (props.swipedIndex === index) {
                          props.setSwipedIndex(null);
                          return;
                        }
                        const hasRoute = item.route && item.route !== '';
                        const isTpaAlarm =
                          IsTraCustom02EduLogAlarmGubun(item.alarmGubun) &&
                          (item.alarmData || item.responseData);
                        if (hasRoute || isTpaAlarm) {
                          props.MeetingAlarmCheck(item);
                        } else {
                          props.AlarmCheck(item);
                        }
                      }}
                    >
                      <Avatar
                        alt="alarmIcon"
                        src={
                          item.route === '/MeetingRespon'
                            ? props.AlarIcon.Meeting
                            : props.AlarIcon.Notice
                        }
                        sx={{
                          width: '8%',
                          height: '8%',
                          m: 0.75,
                          borderRadius: '50%',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        }}
                      />
                      <ListItemText
                        sx={{ px: 1.5 }}
                        primary={item.title}
                        primaryTypographyProps={{
                          sx: { fontWeight: 'bold' },
                        }}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{ color: 'text.primary', display: 'block' }}
                            ></Typography>
                            {item.comment}
                          </React.Fragment>
                        }
                      />
                      <ListItemText
                        secondary={
                          <Typography
                            component="span"
                            variant="body2"
                            sx={{
                              color: 'text.primary',
                              display: 'block',
                              textAlign: 'end',
                              mr: 0.75,
                            }}
                          >
                            {props.FormatDate(item.createDate)}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </Box>
              </React.Fragment>
            ))}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                py: 2,
              }}
            >
              <Divider sx={{ flex: 1, borderColor: '#E0E0E0' }} />
              <Typography
                sx={{
                  px: 2,
                  color: '#B0B4BA',
                  fontSize: '0.875em',
                  whiteSpace: 'nowrap',
                }}
              >
                7일 전 알림까지 확인할 수 있어요
              </Typography>
              <Divider sx={{ flex: 1, borderColor: '#E0E0E0' }} />
            </Box>
          </List>
        ) : (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="h5"
              sx={{
                textAlign: 'center',
                fontWeight: 'bold',
                color: '#504c4cff',
                fontSize: '1.2rem',
              }}
            >
              {'현재 받은 알림이 없습니다.'}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default AlarmList;
